export const PAGE_VALIDATION_CONSTANTS = {
  ACTION_LINE: 'ACTION_LINE',
  TICKET_PANEL: 'TICKET_PANEL',
  ATTACHMENTS: 'ATTACHMENTS',
  TEMPLATE: 'TEMPLATE',
  ME_MENU: 'ME_MENU',
};
